import React from "react";
import { Navigate } from "react-router-dom";

function ConditionalRoute({ condition, to, children }) {
  if (condition) {
    return <Navigate to={to} replace />;
  }
  return children;
}
export default ConditionalRoute;
